import 'jquery-validation-unobtrusive';
import Common from './common';
import RememberMe from './rememberMe.model';
import EncryptModel from './encrypt.model'

export default class AuthenticateModel {
	private signUpFormControl: Common;

	private rememberMeStorageKey: string = 'rememberMe';

	private rememberMeCheckBoxSelector: string = '#rememberMe';
	private signInEmailSelector: string = '#signinEmail';
	private signInFormSelector: string = '#signInForm';

	private $signInForm: JQuery<HTMLElement>;
	private $signInEmail: JQuery<HTMLElement>;
	private $rememberMeCheckBox: JQuery<HTMLElement>;

	public initialize(): void {
		const rememberMeOptions = window.storageService.getKey<RememberMe>(this.rememberMeStorageKey);

		this.signUpFormControl = new Common('#signUpForm');

		$('#first-name, #last-name, #signup-email').on('blur keyup', function () {
			if ($("#signUpForm").valid()) {
				$('#btnSubmit').prop('disabled', false);
			} else {
				$('#btnSubmit').prop('disabled', 'disabled');
			}

			if ($('#agreementAccepted').prop('checked') === false) {
				$('#btnSubmit').prop('disabled', 'disabled');
			}
		});

		this.$signInForm = $(this.signInFormSelector);
		this.$rememberMeCheckBox = $(this.rememberMeCheckBoxSelector);
		this.$signInEmail = this.$signInForm.find(this.signInEmailSelector);

		this.$signInForm.submit(event => this.onSignInSuccess(event));

		if (!!rememberMeOptions) {
			this.$signInEmail.val(rememberMeOptions.email);
			this.$rememberMeCheckBox.prop('checked', rememberMeOptions.rememberMe);
		}
	}

	private onSignInSuccess(event: JQuery.Event): void {

		new EncryptModel(this.signInFormSelector);
		
		if (this.$rememberMeCheckBox.is(':checked')) {
			const email: string = <string>this.$signInEmail.val();
			const rememberMeOptions: RememberMe = {
				email: email,
				rememberMe: true
			};
			window.storageService.setKey(this.rememberMeStorageKey, rememberMeOptions);
		} else {
			window.storageService.removeKey(this.rememberMeStorageKey);
		}
	}
}

window.authenticateModel = new AuthenticateModel();



// WEBPACK FOOTER //
// ./Client/Scripts/models/authenticate.model.ts